import { createFileRoute, redirect } from '@tanstack/react-router'
import { ROUTE_PATHS } from '@/config/app.config'
import { useAuthStore } from '@/features/auth/stores/auth.store'
import { InviteTermsPage } from '@/features/invite-terms'

interface InviteTermsSearch {
  /** Invite token from the invite link (`{APP_URL}/invite-terms?token=…`). */
  token?: string
}

/**
 * `/invite-terms` — public Terms & Conditions screen shown to an invited user
 * before the login screen (AMLIQ-101). The invitee is identified by the invite
 * token in the URL; acceptance is resolved and recorded server-side
 * (swagger/terms.json), so an invitee who has already accepted the current
 * version is bounced onward to sign-in from within the page. Authenticated
 * users have no invite to accept and are sent home.
 */
export const Route = createFileRoute('/invite-terms')({
  validateSearch: (search: Record<string, unknown>): InviteTermsSearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: ROUTE_PATHS.root })
    }
  },
  component: InviteTermsRoute,
})

function InviteTermsRoute() {
  const { token } = Route.useSearch()
  return <InviteTermsPage token={token} />
}
